import {inject, Injectable} from '@angular/core';
import {FieldAnomalyService} from '@6grain/masofa-monolith-api-client/dictionaries';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {fieldAnomalyRowsToCodeMap} from './field-details-recommendations.util';
import {FilterOperator} from '@app/utils/filter-operator';

@Injectable({providedIn: 'root'})
export class FieldDetailsRecommendationsService {
  private readonly fieldAnomalyService = inject(FieldAnomalyService);

  /**
   * Loads `/FieldAnomaly/GetByQuery` filtered to only the {@code codeFromEnum} values
   * present in the current field's anomalies, then indexes rows by code.
   */
  loadFieldAnomaliesByCode$(codes: number[]): Observable<Map<number, unknown>> {
    if (!codes.length) {
      return of(new Map<number, unknown>());
    }
    return this.fieldAnomalyService
      .dictionariesFieldAnomalyGetByQueryPost({
        filters: [
          {
            filterField: 'codeFromEnum',
            filterOperator: FilterOperator.AnyOf,
            filterValue: codes,
          },
        ],
        take: codes.length + 10,
        offset: 0,
      } as any)
      .pipe(
        catchError(() => of([] as unknown[])),
        map(rows => fieldAnomalyRowsToCodeMap(rows)),
      );
  }
}
